import { render, staticRenderFns } from "./MakeSegmentModal.vue?vue&type=template&id=aa99afa0&scoped=true&"
import script from "./MakeSegmentModal.vue?vue&type=script&lang=js&"
export * from "./MakeSegmentModal.vue?vue&type=script&lang=js&"
import style0 from "./MakeSegmentModal.vue?vue&type=style&index=0&id=aa99afa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa99afa0",
  null
  
)

export default component.exports